import { PATH } from "../constant";

export function getPage(routhMaths:any){

    switch (routhMaths.path) {
      case PATH.CREATE:
        return PATH.CREATE;
      case PATH.HOME:
        return PATH.HOME;
      case PATH.DETAIL:
        return PATH.DETAIL;
      default:
        return PATH.HOME;
    }
}